import { Helmet } from "react-helmet";
import BayanListPage from "../BayanList/BayanListPage";

const FridayBayanComponent = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Explore the latest Friday bayans from our mosque. Listen to inspiring bayans delivered weekly, available for easy accessibility on our website."
        />
        <title>Latest Friday Bayans | Mosque Audio</title>
      </Helmet>

      <BayanListPage
        apiType="friday"
        pageTitle="Friday Bayan"
        pageSubtitle="Weekly Audio Listening"
        countPerPage={10}
      />
    </>
  );
};

export default FridayBayanComponent;
